import {Injectable, Renderer2, RendererFactory2} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HtmlUtils {
  private static HTML_ESCAPE_DOM = document.createElement('div');
  private scrollBarWidth: number;
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
  * Escaping s for use in html.
  * @param s
  */
  public static escapeHTML(s: string): string {
    if (!s) {
      return '';
    }
    this.HTML_ESCAPE_DOM.innerText = s;
    return this.HTML_ESCAPE_DOM.innerHTML;
  }

  public static getPathSegments(url: string | URL): string[] {
    return (url instanceof URL ? url : new URL(url)).pathname.split('/').slice(1);
  }

  public getScrollBarWidth(): number {
    if (this.scrollBarWidth != null) {
      return this.scrollBarWidth;
    }
    const divElement = this.renderer.createElement('div');
    this.renderer.setStyle(divElement, 'overflow', 'scroll');
    this.renderer.setStyle(divElement, 'visibility', 'hidden');
    this.renderer.setStyle(divElement, 'position', 'absolute');
    this.renderer.appendChild(document.body, divElement);
    const scrollBarWidth = divElement.offsetWidth - divElement.clientWidth;
    this.renderer.removeChild(document.body, divElement);
    this.scrollBarWidth = scrollBarWidth;
    return scrollBarWidth;
  };

  public static italicize(content: string): string {
    return '<span class="fst-italic">' + content + '</span>';
  }

  public downloadFile(filename: string, fileUrl: string): void {
    const link = this.renderer.createElement('a');
    link.classList.add('d-none');
    link.href = fileUrl;
    link.download = filename;
    this.renderer.appendChild(document.body, link);
    link.click();
    this.renderer.removeChild(document.body, link);
  }
}
